"use strict";
const _ = require('lodash');
_.mixin(require('lodash-uuid'));
const { srsEUR6PalletArticle } = require('../article');
const SRS_EUR6_COST = 200;
function createSRSPalletRows() {
    return [
        {
            id: _.uuid(),
            name: srsEUR6PalletArticle.name,
            price: SRS_EUR6_COST,
            unit: 'single',
            deliveredQuantity: 1,
            article: srsEUR6PalletArticle,
            total: SRS_EUR6_COST,
            lookups: {
                article: { articleNumber: srsEUR6PalletArticle.articleNumber },
            },
        },
    ];
}
module.exports = {
    createSRSPalletRows,
};
